import { cn } from "@/lib/utils"
import { forwardRef, HTMLAttributes } from "react"

interface RestaurantSectionProps extends HTMLAttributes<HTMLDivElement> {
  id: string;
  title?: string;
}

const RestaurantSection = forwardRef<HTMLDivElement, RestaurantSectionProps>(
  ({ className, children, title, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("scroll-mt-[160px]", className)}
        {...props}
      >
        {title && (
          <h3 className="text-sm font-medium text-muted-foreground mb-2">
            {title}
          </h3>
        )}
        {children}
      </div>
    )
  }
)
RestaurantSection.displayName = "RestaurantSection"

export { RestaurantSection }